import React, { Suspense } from 'react';
import GameCardsLineSkeleton from '../../GameCardsLine/Skeleton';

const GameCardsLineCategory = React.lazy(() =>
  import('./GameCardsLineCategory')
);

// TODO remove after deleting Dashboard page in favor of DashboardConfigurable
const GameCardsLineCategoryAsync = (props) => (
  <Suspense fallback={<GameCardsLineSkeleton {...props} />}>
    <GameCardsLineCategory {...props} />
  </Suspense>
);

export default GameCardsLineCategoryAsync;
